const FormHeader: React.FC = () => {

return (
    <>
            <div className="text-center mb-3">
                <h2 className="text-blueGray-500 text-lg font-bold">Welcome Back!</h2>
            </div>
            <div className="text-center mb-3">
                <h3 className="text-blueGray-500 text-sm font-bold">
                    Please Provide Your Credential
                </h3>
            </div>
            <hr className="mt-6 border-b-1 border-black" />
    </>
    );
};

export default FormHeader;
